import "react";
import { jsx } from "react/jsx-runtime";
import { FloatingDelayGroup } from "@floating-ui/react";
//#region src/components/Tooltip/TooltipProvider.tsx
var hoverDelay = {
	open: 300,
	close: 0
};
/**
* Enables tooltips to share a global "warm-up" period for their hover delay.
* You must wrap your application in this component for tooltips to function.
*/
var TooltipProvider = ({ children }) => /* @__PURE__ */ jsx(FloatingDelayGroup, {
	delay: hoverDelay,
	timeoutMs: 300,
	children
});
TooltipProvider.displayName = "TooltipProvider";
//#endregion
export { TooltipProvider, hoverDelay };

//# sourceMappingURL=TooltipProvider.js.map